import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-6eef00a9"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 0,
  class: "wrapper"
}
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "icon icon-back" }, null, -1))
const _hoisted_3 = { class: "title" }
const _hoisted_4 = { class: "email-confirm" }
const _hoisted_5 = {
  href: "javascript:void(0);",
  class: "email-confirm-text"
}
const _hoisted_6 = { class: "enable-all" }
const _hoisted_7 = { class: "enable-all-text" }
const _hoisted_8 = { class: "notification-card" }
const _hoisted_9 = { class: "notification-card-title" }
const _hoisted_10 = { class: "notification-card-item" }
const _hoisted_11 = { class: "notification-card-item" }
const _hoisted_12 = { class: "notification-card" }
const _hoisted_13 = { class: "notification-card-title" }
const _hoisted_14 = { class: "notification-card-item" }
const _hoisted_15 = { class: "notification-card-item" }
const _hoisted_16 = { class: "notification-card" }
const _hoisted_17 = { class: "notification-card-title" }
const _hoisted_18 = { class: "notification-card-item" }
const _hoisted_19 = { class: "notification-card-item" }
const _hoisted_20 = { class: "notification-card" }
const _hoisted_21 = { class: "notification-card-title" }
const _hoisted_22 = { class: "notification-card-item" }
const _hoisted_23 = { class: "notification-card-item" }
const _hoisted_24 = { class: "notification-card" }
const _hoisted_25 = { class: "notification-card-title" }
const _hoisted_26 = { class: "notification-card-item" }
const _hoisted_27 = { class: "notification-card-item" }
const _hoisted_28 = {
  key: 1,
  class: "d-wrapper"
}
const _hoisted_29 = { class: "d-notifications-wrapper" }
const _hoisted_30 = { class: "left" }
const _hoisted_31 = { class: "d-aside" }
const _hoisted_32 = { class: "d-aside__main-menu" }
const _hoisted_33 = { class: "right" }
const _hoisted_34 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "icon icon-close" }, null, -1))
const _hoisted_35 = { class: "d-email-confirm" }
const _hoisted_36 = {
  href: "javascript:void(0);",
  class: "email-confirm-text"
}
const _hoisted_37 = { class: "enable-all" }
const _hoisted_38 = { class: "enable-all-text" }
const _hoisted_39 = { class: "notification-card" }
const _hoisted_40 = { class: "notification-card-title" }
const _hoisted_41 = { class: "notification-card-item" }
const _hoisted_42 = { class: "notification-card-item" }
const _hoisted_43 = { class: "notification-card" }
const _hoisted_44 = { class: "notification-card-title" }
const _hoisted_45 = { class: "notification-card-item" }
const _hoisted_46 = { class: "notification-card-item" }
const _hoisted_47 = { class: "notification-card" }
const _hoisted_48 = { class: "notification-card-title" }
const _hoisted_49 = { class: "notification-card-item" }
const _hoisted_50 = { class: "notification-card-item" }
const _hoisted_51 = { class: "notification-card" }
const _hoisted_52 = { class: "notification-card-title" }
const _hoisted_53 = { class: "notification-card-item" }
const _hoisted_54 = { class: "notification-card-item" }
const _hoisted_55 = { class: "notification-card" }
const _hoisted_56 = { class: "notification-card-title" }
const _hoisted_57 = { class: "notification-card-item" }
const _hoisted_58 = { class: "notification-card-item" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")!
  const _component_app_header = _resolveComponent("app-header")!
  const _component_el_switch = _resolveComponent("el-switch")!
  const _component_desktop_header = _resolveComponent("desktop-header")!
  const _component_drive_aside_main_menu = _resolveComponent("drive-aside-main-menu")!

  return (_ctx.mainStore.isMobile)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createVNode(_component_app_header, { class: "header" }, {
          "top-left": _withCtx(() => [
            _createVNode(_component_router_link, {
              to: "/settings",
              class: "back-link"
            }, {
              default: _withCtx(() => [
                _hoisted_2
              ]),
              _: 1
            })
          ]),
          "top-middle": _withCtx(() => [
            _createElementVNode("div", _hoisted_3, _toDisplayString(_ctx.$localize('settings.notifications.title')), 1)
          ]),
          _: 1
        }),
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("a", _hoisted_5, _toDisplayString(_ctx.$localize('settings.notifications.confirm.email')), 1)
        ]),
        _createElementVNode("div", null, [
          _createElementVNode("div", _hoisted_6, [
            _createElementVNode("div", _hoisted_7, _toDisplayString(_ctx.$localize('settings.notifications.enable.all')), 1),
            _createVNode(_component_el_switch, {
              onChange: _ctx.switchAll,
              modelValue: _ctx.enableAll,
              "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.enableAll) = $event)),
              size: "large",
              class: "notifications-switcher",
              style: {"--el-switch-on-color":"#13ce66"}
            }, null, 8, ["onChange", "modelValue"])
          ]),
          _createElementVNode("div", _hoisted_8, [
            _createElementVNode("div", _hoisted_9, _toDisplayString(_ctx.$localize('settings.notifications.send.message')), 1),
            _createElementVNode("div", _hoisted_10, [
              _createElementVNode("div", null, _toDisplayString(_ctx.$localize('settings.notifications.toggle.email')), 1),
              _createVNode(_component_el_switch, {
                modelValue: _ctx.mainStore.notificationSettings.mail[0].enabled,
                "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.mainStore.notificationSettings.mail[0].enabled) = $event)),
                onChange: _ctx.updateNotificationSettings,
                size: "large",
                class: "notifications-switcher",
                style: {"--el-switch-on-color":"#13ce66"}
              }, null, 8, ["modelValue", "onChange"])
            ]),
            _createElementVNode("div", _hoisted_11, [
              _createElementVNode("div", null, _toDisplayString(_ctx.$localize('settings.notifications.toggle.push')), 1),
              _createVNode(_component_el_switch, {
                modelValue: _ctx.mainStore.notificationSettings.push[0].enabled,
                "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.mainStore.notificationSettings.push[0].enabled) = $event)),
                onChange: _ctx.updateNotificationSettings,
                size: "large",
                class: "notifications-switcher",
                style: {"--el-switch-on-color":"#13ce66"}
              }, null, 8, ["modelValue", "onChange"])
            ])
          ]),
          _createElementVNode("div", _hoisted_12, [
            _createElementVNode("div", _hoisted_13, _toDisplayString(_ctx.$localize('settings.notifications.send.case')), 1),
            _createElementVNode("div", _hoisted_14, [
              _createElementVNode("div", null, _toDisplayString(_ctx.$localize('settings.notifications.toggle.email')), 1),
              _createVNode(_component_el_switch, {
                modelValue: _ctx.mainStore.notificationSettings.mail[1].enabled,
                "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.mainStore.notificationSettings.mail[1].enabled) = $event)),
                onChange: _ctx.updateNotificationSettings,
                size: "large",
                class: "notifications-switcher",
                style: {"--el-switch-on-color":"#13ce66"}
              }, null, 8, ["modelValue", "onChange"])
            ]),
            _createElementVNode("div", _hoisted_15, [
              _createElementVNode("div", null, _toDisplayString(_ctx.$localize('settings.notifications.toggle.push')), 1),
              _createVNode(_component_el_switch, {
                modelValue: _ctx.mainStore.notificationSettings.push[1].enabled,
                "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.mainStore.notificationSettings.push[1].enabled) = $event)),
                onChange: _ctx.updateNotificationSettings,
                size: "large",
                class: "notifications-switcher",
                style: {"--el-switch-on-color":"#13ce66"}
              }, null, 8, ["modelValue", "onChange"])
            ])
          ]),
          _createElementVNode("div", _hoisted_16, [
            _createElementVNode("div", _hoisted_17, _toDisplayString(_ctx.$localize('settings.notifications.send.photo')), 1),
            _createElementVNode("div", _hoisted_18, [
              _createElementVNode("div", null, _toDisplayString(_ctx.$localize('settings.notifications.toggle.email')), 1),
              _createVNode(_component_el_switch, {
                modelValue: _ctx.mainStore.notificationSettings.mail[2].enabled,
                "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.mainStore.notificationSettings.mail[2].enabled) = $event)),
                onChange: _ctx.updateNotificationSettings,
                size: "large",
                class: "notifications-switcher",
                style: {"--el-switch-on-color":"#13ce66"}
              }, null, 8, ["modelValue", "onChange"])
            ]),
            _createElementVNode("div", _hoisted_19, [
              _createElementVNode("div", null, _toDisplayString(_ctx.$localize('settings.notifications.toggle.push')), 1),
              _createVNode(_component_el_switch, {
                modelValue: _ctx.mainStore.notificationSettings.push[2].enabled,
                "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.mainStore.notificationSettings.push[2].enabled) = $event)),
                onChange: _ctx.updateNotificationSettings,
                size: "large",
                class: "notifications-switcher",
                style: {"--el-switch-on-color":"#13ce66"}
              }, null, 8, ["modelValue", "onChange"])
            ])
          ]),
          _createElementVNode("div", _hoisted_20, [
            _createElementVNode("div", _hoisted_21, _toDisplayString(_ctx.$localize('settings.notifications.send.file')), 1),
            _createElementVNode("div", _hoisted_22, [
              _createElementVNode("div", null, _toDisplayString(_ctx.$localize('settings.notifications.toggle.email')), 1),
              _createVNode(_component_el_switch, {
                modelValue: _ctx.mainStore.notificationSettings.mail[3].enabled,
                "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.mainStore.notificationSettings.mail[3].enabled) = $event)),
                onChange: _ctx.updateNotificationSettings,
                size: "large",
                class: "notifications-switcher",
                style: {"--el-switch-on-color":"#13ce66"}
              }, null, 8, ["modelValue", "onChange"])
            ]),
            _createElementVNode("div", _hoisted_23, [
              _createElementVNode("div", null, _toDisplayString(_ctx.$localize('settings.notifications.toggle.push')), 1),
              _createVNode(_component_el_switch, {
                modelValue: _ctx.mainStore.notificationSettings.push[3].enabled,
                "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((_ctx.mainStore.notificationSettings.push[3].enabled) = $event)),
                onChange: _ctx.updateNotificationSettings,
                size: "large",
                class: "notifications-switcher",
                style: {"--el-switch-on-color":"#13ce66"}
              }, null, 8, ["modelValue", "onChange"])
            ])
          ]),
          _createElementVNode("div", _hoisted_24, [
            _createElementVNode("div", _hoisted_25, _toDisplayString(_ctx.$localize('settings.notifications.send.connection')), 1),
            _createElementVNode("div", _hoisted_26, [
              _createElementVNode("div", null, _toDisplayString(_ctx.$localize('settings.notifications.toggle.email')), 1),
              _createVNode(_component_el_switch, {
                modelValue: _ctx.mainStore.notificationSettings.mail[4].enabled,
                "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((_ctx.mainStore.notificationSettings.mail[4].enabled) = $event)),
                onChange: _ctx.updateNotificationSettings,
                size: "large",
                class: "notifications-switcher",
                style: {"--el-switch-on-color":"#13ce66"}
              }, null, 8, ["modelValue", "onChange"])
            ]),
            _createElementVNode("div", _hoisted_27, [
              _createElementVNode("div", null, _toDisplayString(_ctx.$localize('settings.notifications.toggle.push')), 1),
              _createVNode(_component_el_switch, {
                modelValue: _ctx.mainStore.notificationSettings.push[4].enabled,
                "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => ((_ctx.mainStore.notificationSettings.push[4].enabled) = $event)),
                onChange: _ctx.updateNotificationSettings,
                size: "large",
                class: "notifications-switcher",
                style: {"--el-switch-on-color":"#13ce66"}
              }, null, 8, ["modelValue", "onChange"])
            ])
          ])
        ])
      ]))
    : (_openBlock(), _createElementBlock("div", _hoisted_28, [
        _createVNode(_component_desktop_header),
        _createElementVNode("div", _hoisted_29, [
          _createElementVNode("div", _hoisted_30, [
            _createElementVNode("aside", _hoisted_31, [
              _createElementVNode("div", _hoisted_32, [
                _createVNode(_component_drive_aside_main_menu)
              ])
            ])
          ]),
          _createElementVNode("div", _hoisted_33, [
            _createVNode(_component_router_link, {
              to: "/settings",
              class: "close"
            }, {
              default: _withCtx(() => [
                _hoisted_34
              ]),
              _: 1
            }),
            _createElementVNode("div", _hoisted_35, [
              _createElementVNode("a", _hoisted_36, _toDisplayString(_ctx.$localize('settings.notifications.confirm.email')), 1)
            ]),
            _createElementVNode("div", null, [
              _createElementVNode("div", _hoisted_37, [
                _createElementVNode("div", _hoisted_38, _toDisplayString(_ctx.$localize('settings.notifications.enable.all')), 1),
                _createVNode(_component_el_switch, {
                  onChange: _ctx.switchAll,
                  modelValue: _ctx.enableAll,
                  "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event: any) => ((_ctx.enableAll) = $event)),
                  size: "large",
                  class: "notifications-switcher",
                  style: {"--el-switch-on-color":"#13ce66"}
                }, null, 8, ["onChange", "modelValue"])
              ]),
              _createElementVNode("div", _hoisted_39, [
                _createElementVNode("div", _hoisted_40, _toDisplayString(_ctx.$localize('settings.notifications.send.message')), 1),
                _createElementVNode("div", _hoisted_41, [
                  _createElementVNode("div", null, _toDisplayString(_ctx.$localize('settings.notifications.toggle.email')), 1),
                  _createVNode(_component_el_switch, {
                    modelValue: _ctx.mainStore.notificationSettings.mail[0].enabled,
                    "onUpdate:modelValue": _cache[12] || (_cache[12] = ($event: any) => ((_ctx.mainStore.notificationSettings.mail[0].enabled) = $event)),
                    onChange: _ctx.updateNotificationSettings,
                    size: "large",
                    class: "notifications-switcher",
                    style: {"--el-switch-on-color":"#13ce66"}
                  }, null, 8, ["modelValue", "onChange"])
                ]),
                _createElementVNode("div", _hoisted_42, [
                  _createElementVNode("div", null, _toDisplayString(_ctx.$localize('settings.notifications.toggle.push')), 1),
                  _createVNode(_component_el_switch, {
                    modelValue: _ctx.mainStore.notificationSettings.push[0].enabled,
                    "onUpdate:modelValue": _cache[13] || (_cache[13] = ($event: any) => ((_ctx.mainStore.notificationSettings.push[0].enabled) = $event)),
                    onChange: _ctx.updateNotificationSettings,
                    size: "large",
                    class: "notifications-switcher",
                    style: {"--el-switch-on-color":"#13ce66"}
                  }, null, 8, ["modelValue", "onChange"])
                ])
              ]),
              _createElementVNode("div", _hoisted_43, [
                _createElementVNode("div", _hoisted_44, _toDisplayString(_ctx.$localize('settings.notifications.send.case')), 1),
                _createElementVNode("div", _hoisted_45, [
                  _createElementVNode("div", null, _toDisplayString(_ctx.$localize('settings.notifications.toggle.email')), 1),
                  _createVNode(_component_el_switch, {
                    modelValue: _ctx.mainStore.notificationSettings.mail[1].enabled,
                    "onUpdate:modelValue": _cache[14] || (_cache[14] = ($event: any) => ((_ctx.mainStore.notificationSettings.mail[1].enabled) = $event)),
                    onChange: _ctx.updateNotificationSettings,
                    size: "large",
                    class: "notifications-switcher",
                    style: {"--el-switch-on-color":"#13ce66"}
                  }, null, 8, ["modelValue", "onChange"])
                ]),
                _createElementVNode("div", _hoisted_46, [
                  _createElementVNode("div", null, _toDisplayString(_ctx.$localize('settings.notifications.toggle.push')), 1),
                  _createVNode(_component_el_switch, {
                    modelValue: _ctx.mainStore.notificationSettings.push[1].enabled,
                    "onUpdate:modelValue": _cache[15] || (_cache[15] = ($event: any) => ((_ctx.mainStore.notificationSettings.push[1].enabled) = $event)),
                    onChange: _ctx.updateNotificationSettings,
                    size: "large",
                    class: "notifications-switcher",
                    style: {"--el-switch-on-color":"#13ce66"}
                  }, null, 8, ["modelValue", "onChange"])
                ])
              ]),
              _createElementVNode("div", _hoisted_47, [
                _createElementVNode("div", _hoisted_48, _toDisplayString(_ctx.$localize('settings.notifications.send.photo')), 1),
                _createElementVNode("div", _hoisted_49, [
                  _createElementVNode("div", null, _toDisplayString(_ctx.$localize('settings.notifications.toggle.email')), 1),
                  _createVNode(_component_el_switch, {
                    modelValue: _ctx.mainStore.notificationSettings.mail[2].enabled,
                    "onUpdate:modelValue": _cache[16] || (_cache[16] = ($event: any) => ((_ctx.mainStore.notificationSettings.mail[2].enabled) = $event)),
                    onChange: _ctx.updateNotificationSettings,
                    size: "large",
                    class: "notifications-switcher",
                    style: {"--el-switch-on-color":"#13ce66"}
                  }, null, 8, ["modelValue", "onChange"])
                ]),
                _createElementVNode("div", _hoisted_50, [
                  _createElementVNode("div", null, _toDisplayString(_ctx.$localize('settings.notifications.toggle.push')), 1),
                  _createVNode(_component_el_switch, {
                    modelValue: _ctx.mainStore.notificationSettings.push[2].enabled,
                    "onUpdate:modelValue": _cache[17] || (_cache[17] = ($event: any) => ((_ctx.mainStore.notificationSettings.push[2].enabled) = $event)),
                    onChange: _ctx.updateNotificationSettings,
                    size: "large",
                    class: "notifications-switcher",
                    style: {"--el-switch-on-color":"#13ce66"}
                  }, null, 8, ["modelValue", "onChange"])
                ])
              ]),
              _createElementVNode("div", _hoisted_51, [
                _createElementVNode("div", _hoisted_52, _toDisplayString(_ctx.$localize('settings.notifications.send.file')), 1),
                _createElementVNode("div", _hoisted_53, [
                  _createElementVNode("div", null, _toDisplayString(_ctx.$localize('settings.notifications.toggle.email')), 1),
                  _createVNode(_component_el_switch, {
                    modelValue: _ctx.mainStore.notificationSettings.mail[3].enabled,
                    "onUpdate:modelValue": _cache[18] || (_cache[18] = ($event: any) => ((_ctx.mainStore.notificationSettings.mail[3].enabled) = $event)),
                    onChange: _ctx.updateNotificationSettings,
                    size: "large",
                    class: "notifications-switcher",
                    style: {"--el-switch-on-color":"#13ce66"}
                  }, null, 8, ["modelValue", "onChange"])
                ]),
                _createElementVNode("div", _hoisted_54, [
                  _createElementVNode("div", null, _toDisplayString(_ctx.$localize('settings.notifications.toggle.push')), 1),
                  _createVNode(_component_el_switch, {
                    modelValue: _ctx.mainStore.notificationSettings.push[3].enabled,
                    "onUpdate:modelValue": _cache[19] || (_cache[19] = ($event: any) => ((_ctx.mainStore.notificationSettings.push[3].enabled) = $event)),
                    onChange: _ctx.updateNotificationSettings,
                    size: "large",
                    class: "notifications-switcher",
                    style: {"--el-switch-on-color":"#13ce66"}
                  }, null, 8, ["modelValue", "onChange"])
                ])
              ]),
              _createElementVNode("div", _hoisted_55, [
                _createElementVNode("div", _hoisted_56, _toDisplayString(_ctx.$localize('settings.notifications.send.connection')), 1),
                _createElementVNode("div", _hoisted_57, [
                  _createElementVNode("div", null, _toDisplayString(_ctx.$localize('settings.notifications.toggle.email')), 1),
                  _createVNode(_component_el_switch, {
                    modelValue: _ctx.mainStore.notificationSettings.mail[4].enabled,
                    "onUpdate:modelValue": _cache[20] || (_cache[20] = ($event: any) => ((_ctx.mainStore.notificationSettings.mail[4].enabled) = $event)),
                    onChange: _ctx.updateNotificationSettings,
                    size: "large",
                    class: "notifications-switcher",
                    style: {"--el-switch-on-color":"#13ce66"}
                  }, null, 8, ["modelValue", "onChange"])
                ]),
                _createElementVNode("div", _hoisted_58, [
                  _createElementVNode("div", null, _toDisplayString(_ctx.$localize('settings.notifications.toggle.push')), 1),
                  _createVNode(_component_el_switch, {
                    modelValue: _ctx.mainStore.notificationSettings.push[4].enabled,
                    "onUpdate:modelValue": _cache[21] || (_cache[21] = ($event: any) => ((_ctx.mainStore.notificationSettings.push[4].enabled) = $event)),
                    onChange: _ctx.updateNotificationSettings,
                    size: "large",
                    class: "notifications-switcher",
                    style: {"--el-switch-on-color":"#13ce66"}
                  }, null, 8, ["modelValue", "onChange"])
                ])
              ])
            ])
          ])
        ])
      ]))
}